import type { LoggerAdapter } from '../types'

export const consoleLog = (): LoggerAdapter => {
  let enabled = process.env.PRINT_ERRORS === 'yes'

  const adapter: LoggerAdapter = {
    updateContext: context => {
      if ('experiments' in context && context.experiments) {
        const { experiments } = context
        if (experiments['specs.wixDataClient.LogSentryErrorsToConsole']) {
          enabled =
            experiments['specs.wixDataClient.LogSentryErrorsToConsole'] ===
            'true'
        }
      }
    },
    error: (error, extras) => {
      if (enabled) {
        // eslint-disable-next-line no-console
        console.error('wix-data-client error', error, { extras })
      }
    },
  }

  return adapter
}
